import { Map } from "@/shared/components/control";
import type { TeaserItem } from "@/config/site";
import { BlurredMedia, Section } from "@/shared/components/ui";
import { useTranslation } from "react-i18next";

type TeaserGridProps = {
  items: readonly TeaserItem[];
};

export function TeaserGrid({ items }: TeaserGridProps) {
  const { t } = useTranslation();
  return (
    <Section className="border-b border-border-soft">
      <p className="max-w-2xl text-pretty text-[calc(1.05rem+0.15vw)] font-normal leading-relaxed text-ink-secondary">
        {t("home.teaser.intro")}
      </p>
      <div className="mt-12 grid gap-4 sm:grid-cols-2">
        <Map
          items={items}
          keyExtractor={(_, i) => `teaser-${i}`}
          render={item => <TeaserCell item={item} />}
        />
      </div>
    </Section>
  );
}

function TeaserCell({ item }: { item: TeaserItem }) {
  return (
    <BlurredMedia
      src={item.src}
      alt={item.alt}
      caption={item.caption}
      blurClass={item.blurClass}
      objectPosition={item.objectPosition}
    />
  );
}
